import cs from 'classnames';
import { CSSProperties, PropsWithChildren } from 'react';
import { Spinner } from 'react-bootstrap';

import './Loading.scss';

type LoadingHeight = number | 'full' | string;

interface LoadingProps {
  /** 높이. 숫자=vh, 'full'=100vh, 그 외 문자열=CSS 값(예 '8rem'). 기본 70 */
  height?: LoadingHeight;
  /** 어두운 dim + blur 배경 */
  dim?: boolean;
  /** 화면 전체를 덮는 fixed 전면 오버레이(전역 로딩 락). height 무시 */
  overlay?: boolean;
}

function resolveHeight(height: LoadingHeight): string {
  if (height === 'full') {
    return '100vh';
  }
  return typeof height === 'number' ? `${height}vh` : height;
}

export default function Loading({ height = 70, dim, overlay }: LoadingProps) {
  const className = cs('Loading', 'flex_center', { dim, overlay });
  const style: CSSProperties | undefined = overlay ? undefined : { height: resolveHeight(height) };

  return (
    <div className={className} style={style}>
      <Spinner animation="border"></Spinner>
    </div>
  );
}

interface LoadingOrProps extends LoadingProps {
  isLoading?: boolean;
}

/** 로딩 중엔 스피너, 아니면 children (기존 Loading2 대체) */
export function LoadingOr({ isLoading, children, ...props }: PropsWithChildren<LoadingOrProps>) {
  return isLoading ? <Loading {...props} /> : <>{children}</>;
}
